import {
  BouncingDot,
  BouncingLoaderWrapper,
} from 'components/BouncingLoader/BouncingLoader.styled';

const BouncingLoader = ({ ...props }) => {
  return (
    <BouncingLoaderWrapper data-testid="bouncing-loader" {...props}>
      <BouncingDot />
      <BouncingDot />
      <BouncingDot />
    </BouncingLoaderWrapper>
  );
};

export default BouncingLoader;
